import type { KgInsightThemeType } from '@api';
import { ThemeLogoIcon } from '@terminal/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';
import clsx from 'clsx';

import styles from './ThemeSearchLogo.module.scss';

export interface ThemeSearchLogoProps {
  name: string;
  logoUrl?: string;
  themeType?: KgInsightThemeType;
  size?: 16 | 32;
}

export const ThemeSearchLogo = ({
  name,
  logoUrl,
  themeType,
  size = 32,
}: ThemeSearchLogoProps) => (
  <ThemeLogoIcon
    name={name}
    logo_url={logoUrl}
    type={themeType}
    size={size}
    fallbackIcon={
      <div
        className={clsx(styles.fallback, {
          [styles.small]: size === 16,
          [styles.industry]: themeType === 'industry',
          [styles.financial]: themeType === 'financial',
          [styles.macro]: themeType === 'macro',
        })}
        data-theme-search-logo
        data-theme-type={themeType}
      >
        {name.charAt(0)}
      </div>
    }
  />
);
